<!-- 告警配查指南 -->
<template>
    <div class="content">
        <el-backtop></el-backtop>
        <ul>
            <li>
                <el-row> <el-link href="#0" :underline="linkUnderline">1、响应数据状态码错误</el-link></el-row>
                <el-row> <el-link href="#1" :underline="linkUnderline">2、临时暂停发送</el-link></el-row>
                <el-row> <el-link href="#2" :underline="linkUnderline">3、等待响应超时</el-link></el-row>
                <el-row> <el-link href="#3" :underline="linkUnderline">4、连接不到服务器</el-link></el-row>
                <el-row> <el-link href="#4" :underline="linkUnderline">5、响应数据格式错误</el-link></el-row>
                <el-row> <el-link href="#5" :underline="linkUnderline">6、HTTP响应状态码错误</el-link></el-row>
                <el-row> <el-link href="#6" :underline="linkUnderline">7、HTTPS证书无效</el-link></el-row>
                <el-row> <el-link href="#7" :underline="linkUnderline">8、网络异常</el-link></el-row>
                <el-row> <el-link href="#8" :underline="linkUnderline">9、原因未知</el-link></el-row>
                <el-row> <el-link href="#9" :underline="linkUnderline">10、XX小时后停止上报</el-link></el-row>
                <el-row> <el-link href="#10" :underline="linkUnderline">11、系统已停止上报权限</el-link></el-row>
                <!-- <el-row> <el-link href="#9" :underline="linkUnderline">10、并发量过大，处理速度慢，获取连接超时</el-link></el-row> -->
            </li>
        </ul>

        <ul>
            <li>
                <h3 id="0">1、响应数据状态码错误</h3>
                <p>
                    当出现此告警内容时，请检查贵司在进行业务处理时
                    是否存在遇到不需要的场的数据、重复数据等数据、不需要的数据等时是否响应了失败，
                    此时请在接收到数据后响应成功。
                </p>
            </li>
        </ul>

        <ul>
            <li>
                <h3 id="1">2、临时暂停发送</h3>
                <p>
                    当出现此告警内容时，由于贵司接入的车场数量比较多，且车场流量比较大，但贵司的服务器业务处理能力不足，
                    导致同时存在大量的连接被占用且长时间没有响应给开放平台，进而导致需要传输给您的数据大量积压。
                    此时，请更改策略，使得占用连接时长缩短，以最快的速度给出应答以释放连接来处理后续数据。
                </p>
            </li>
        </ul>

        <ul>
            <li>
                <h3 id="2">3、等待响应超时</h3>
                <p>
                    当出现该告警内容时，说明在连接上贵司服务器后等待10秒依然没有得到应答，自动断开该次连接。
                    此时，请贵司优化程序以减少连接的占用时长，快速作出应答，以免造成不必要的后果
                </p>
            </li>
        </ul>

        <ul>guide#4
            <li>
                <h3 id="3">4、连接不到服务器</h3>
                <p>
                    当出现此告警内容时，请检查贵司的提供给我司的“服务器地址”是否正确，
                    请尽快确认并提供正确的“服务器地址”到开放平台团队。
                </p>
            </li>
        </ul>

        <ul>
            <li>
                <h3 id="4">5、响应数据格式错误</h3>
                <p>
                    当出现此告警内容时，请检查贵司应答的内容是否为json格式，
                    可参考 <el-link :underline="linkUnderline" type="primary" href="guide#4">接入指南</el-link> 进行修正。
                </p>
            </li>
        </ul>

        <ul>
            <li>
                <h3 id="5">6、HTTP响应状态码错误</h3>
                <p>
                    当出现此告警内容时，请检查贵司应答的http状态码是否为 200，以及是否抛出了异常，
                    请做好异常处理以及http应答码的正确赋值。
                </p>
            </li>
        </ul>

        <ul>
            <li>
                <h3 id="6">7、HTTPS证书无效</h3>
                <p>
                    当出现此告警内容时，请检查贵司提供到开放平台团队的“服务器地址”是否支持 https，如支持，
                    请检查贵司的https证书是否过期、是否有效；否则，请提供正确的“服务器地址”到开放平台团队。
                </p>
            </li>
        </ul>

        <ul>
            <li>
                <h3 id="7">8、网络异常</h3>
                <p>
                    当出现此告警内容时，请检查贵司提供到开放平台团队的“服务器地址”是否允许外网访问以及端口等是否正确，
                    请修正后重新提供正确的“服务器地址”到开放平台团队。
                </p>
            </li>
        </ul>

        <ul>
            <li>
                <h3 id="8">9、原因未知</h3>
                <p>
                    当出现此告警内容时，原因可能为服务器连接数量过多导致自动断开连接或者其他一些未知原因，
                    请检查贵司服务的性能以及消费能力是否充足。
                </p>
            </li>
        </ul>

        <ul>
            <li>
                <h3 id="9">10、XX小时后停止上报</h3>
                <p>
                    当出现告警内容出现“由于推送数据持续失败,系统将在XX小时后停止上报”时，
                    说明开放平台上报数据给贵司时，接收到的响应内容失败次数过多，请参考此前的告警内容进行调整。
                    如调整完成后已无数据上报，请以邮件的形式通知开放平台团队恢复上报权限（附带原因）。
                </p>
            </li>
        </ul>

        <ul>
            <li>
                <h3 id="10">11、系统已停止上报权限</h3>
                <p>
                    当出现告警内容出现“由于推送数据持续失败,系统将在XX小时后停止上报”时，
                    说明开放平台上报数据给贵司时，接收到的响应内容失败次数过多，请参考此前的告警内容进行调整。
                    调整完成后，请以邮件的形式通知开放平台团队恢复上报权限（附带原因）。
                </p>
            </li>
        </ul>

        <!-- <ul>
            <li>
                <h3 id="9">10、并发量过大，处理速度慢，获取连接超时</h3>
                <p>
                    当出现该告警内容时，由于您接入的车场数量比较多，且车场流量比较大，但由于您的服务器业务处理能力不足，
                    导致同时存在大量的连接被占用且长时间没有响应给我方开放平台，进而导致需要传输给您的数据大量积压。
                    此时，请更改策略，使得占用连接时长缩短，以最快的速度给出应答以释放连接来处理后续数据
                </p>
            </li>
        </ul> -->

    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: '',
    props: {
        'Pdatas': {
            type: Object,
        }
    },
    data() {
        return {
            linkUnderline: true,
        }
    },
    computed: {
      ...mapState(["url"])
    },
}
</script>

<style lang="less" scoped>
.content {
    // font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei", '黑体', Arial, sans-serif;
    font-size: 14px; // background-image: url(../../assets/img/back.png);
    line-height: 1.6;
    color: #1f2d3d;
    h3 {
        margin: 0;
        padding: 0px 0 20px 0; // font-family: HiraginoSansGB-W3;
        font-size: 18px;
        color: #111B29;
        letter-spacing: 0
    }
    a {
        text-decoration: none;
        font-size: 13px;
    }
    ul {
        padding: 5px 10px;
        li {
            text-align: left;
        }
    }
    .retract {
        padding-left: 15px;
    }
    pre {
        background-color: #f6f6f6;
        font-size: 12px;
    }
}

.subName {
    padding: 15px 0 10px 15px;
    max-width: 90%;
    min-width: 80%;
    color: #333;
}

table {
    display: table;
    max-width: 90%;
    min-width: 80%;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: auto;
    border-bottom: 1px solid #e7e7eb;
}

thead tr:first-child {
    background-color: #f6f8f9;
}

table tr:first-child {
    border: none;
}

table tr {
    border-top: 1px solid #e7e7eb;
}

table th {
    font-weight: 400;
    color: #8d8d8d;
    text-align: left;
    height: 40px;
    padding: 6px 12px;
    white-space: nowrap;
    border: none;
}

table td {
    // height: 35px;
    padding: 15px 12px;
    text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/Doc/alarmGuide.vue